<template>
    <div v-if="showAt">
        <section id="step">
            <div :class="[step>=4?'comp':'','grid--step']">
                <div class="pt-step">
                    <ul>
                        <li :class="[step>=1?'current':'',step>1?'step01':'']"><span>01.서비스선택</span></li><!--
                        --><li :class="[step>=2?'current':'',step>2?'step02':'']"><span>02.원정보 등록</span></li><!--
                        --><li :class="[step>=3?'current':'',step>3?'step03':'']"><span>03.결제정보등록</span></li><!--
                        --><li :class="[step>=4?'current':'',step==4?'step04':'']"><span>04.서비스신청완료</span></li>
                    </ul>
                </div>
            </div>
        </section>
        <div class="layer-content">
            <div v-if="step == 1">
                <div class="info2">원하시는 서비스를 선택하세요.</div>
                <ul class="sv-req-cho">
                    <!-- 단일상품 single, 결합상품 comb  -->
                    <template v-for="(srvcInfo, index) in step1.srvcList">
                        <li style="cursor:pointer"
                            :key="'srvcInfo' + index"
                            v-if="srvcInfo.showAt">
                            <a :class="[srvcInfo.chkAt?'current':'']">
                                <div class="sv-req-cho-box">
                                    <div :class="srvcInfo.srvcGoodsTitClass" v-text="srvcInfo.srvcGoodsTit"></div>
                                    <div class="__sv-tit" v-text="srvcInfo.srvcNm"></div>
                                    <div class="__sv-txt" v-html="srvcInfo.srvcDc"></div>
                                </div>
                                <div class="sv-req-cho-btn">
                                    <button class="big _bt-blue wp100" @click="btn_srvcReqClick(index)"><span>서비스 신청</span></button>
                                </div>
                            </a>
                        </li>
                    </template>
                </ul>
                <div class="info-txt-bottom">
                    <div class="box-type09 pd20">
                        <ul class="txt-type1 depth2">
                            <li>서비스별 정확한 가격은 원 정보 등록 이후에 확인 가능합니다.</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="grid--con-sub" v-if="step == 2">
                <div class="info2">
                   	 서비스 신청을 위해 <span class="pc02">원 정보 등록</span>을 해주세요.
                </div>
                <table class="tb-row mgt10">
                    <colgroup>
                        <col style="width: 20%">
                        <col style="width: 30%">
                        <col style="width: 20%">
                        <col style="width: 30%">
                    </colgroup>
                    <tbody>
                    <tr>
                        <th>시/도</th>
                        <td>
                            <select class="mgl5"
                                    style="width: calc( 100% - 9px );"
                                    tabindex="1"
                                    v-if="!step2.selFcltAt"
                                    v-model="step2.selSidoCode"
                                    @change="sidoChange()">
                                <option v-for="(sidoInfo,index) in step2.sidoList"
                                        :key="'sidoInfo' + index"
                                        :value="sidoInfo.arcode">
                                    {{sidoInfo.arname}}
                                </option>
                            </select>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;"
                                 v-if="step2.selFcltAt">
                                <span v-text="selSidoNm"></span>
                            </div>
                        </td>
                        <th>원장명</th>
                        <td>
                            <input type="text" class="mgl5" style="width: calc( 100% - 9px );"
                                   tabindex="5"
                                   v-model="fcltInfo.ledgrNm" maxlength="14">
                        </td>
                    </tr>
                    <tr>
                        <th>시/군/구</th>
                        <td>
                            <select class="mgl5"
                                    style="width: calc( 100% - 9px );"
                                    tabindex="2"
                                    v-if="!step2.selFcltAt"
                                    v-model="step2.selSigunCode" >
                                <option v-for="(sigunInfo,index) in step2.sigunList"
                                        :key="'sigunInfo' + index"
                                        :value="sigunInfo.arcode">
                                    {{sigunInfo.arname}}
                                </option>
                            </select>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;"
                                 v-if="step2.selFcltAt">
                                <span v-text="selSigunNm"></span>
                            </div>
                        </td>
                        <!--20200213 문욱제 보육통합 정보 조회 없이 선택가능하도록변경-->
                        <!--<th>설립유형</th>
                        <td>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;">
                                <span v-text="fcltInfo.fcltyTyNm"></span>
                            </div>
                        </td>-->
                        <th>주소</th>
                        <td>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;">
                                <span v-text="fcltInfo.adres"></span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>원명</th>
                        <td>
                            <input type="text"
                                   class="mgl5"
                                   tabindex="3"
                                   style="width: 70% !important;"
                                   maxlength="14"
                                   ref="fcltNm"
                                   v-if="!step2.selFcltAt"
                                   v-model="fcltInfo.fcltNm"
                                   @keyup.enter="btn_fcltSearchClick()"/>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;"
                                 v-if="step2.selFcltAt">
                                <span v-text="fcltInfo.fcltNm"></span>
                            </div>
                            <button class="middle _bt-gray"
                                    style="width:82px;"
                                    @click="btn_fcltSearchClick()">
                                <span>검색</span>
                            </button>
                        </td>
                        <th>전화번호</th>
                        <td>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;">
                                <span v-text="fcltInfo.tlphon"></span>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th>고유번호(사업자등록번호)</th>
                        <td>
                            <input type="text" class="mgl5" style="width: 60px;"
                                   maxlength="3"
                                   tabindex="4"
                                   v-model="fcltInfo.bizrno1"
                                   @keydown="$onbiLib.onlyNumberKeydown()"
                                   @keyup="$onbiLib.onlyNumberKeyup()"> -
                            <input type="text" class="mgl5" style="width: 40px;"
                                   maxlength="2"
                                   tabindex="4"
                                   v-model="fcltInfo.bizrno2"
                                   @keydown="$onbiLib.onlyNumberKeydown()"
                                   @keyup="$onbiLib.onlyNumberKeyup()"> -
                            <input type="text" class="mgl5" style="width: 100px;"
                                   maxlength="5"
                                   tabindex="4"
                                   v-model="fcltInfo.bizrno3"
                                   @keydown="$onbiLib.onlyNumberKeydown()"
                                   @keyup="$onbiLib.onlyNumberKeyup()">
                        </td>
                        <th>아동 수(정원)</th>
                        <td>
                            <div style="float: left;width: 70%;padding: 10px 3px 10px 5px;">
                                <span v-text="fcltInfo.psncpa + '명'"></span>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="info-txt-bottom">
				<span class="info1">
                    원명을 검색하면 설립유형 ~ 아동 수 정보는 어린이집 정보공시 사이트를기준으로 보여집니다.
                </span>
                </div>
                <div class="btn-wrap t-line center mgt40">
                    <button class="big _bt-white"
                            @click="btn_step2BeforeClick()">
                        <span>이전</span>
                    </button>
                    <button class="big _bt-navy"
                            @click="btn_fcltRegClick()">
                        <span>원정보 등록</span>
                    </button>
                </div>
            </div>

            <div v-if="step == 3">
                <div class="balance-sort-wrap">
                    <div class="balance-sort-con box-type04 mgr5">
                        <div class="__in">
                            <div class="entry-cho">
                                <div class="f-left pdt5">
                                    <label for="chk_001" style="cursor: pointer">
                                        <span class="box"></span>
                                        <span class="label-txt">출결상품 구매</span>
                                    </label>
                                </div>
                                <div class="f-right">
                                    <button class="small _bt-white" @click="openOrderSeInfoPopup()"><span>자세히보기</span></button>
                                </div>
                            </div>
                            <table class="tb-none">
                                <colgroup>
                                    <col style="width:30%" />
                                    <col style="width:*" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>안심등하원 신청 수량</th>
                                        <td>
                                            <span>
                                                리더기 수량 :
                                                <input type="text"
                                                        class="mgl5"
                                                        style="width:40px; height:25px;line-height: 16px;"
                                                        maxlength="3"
                                                        @keydown="$onbiLib.onlyNumberKeydown()" v-model="orderInfo.detectorCnt"
                                                        @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;대,&nbsp;&nbsp;
                                                태그 수량 :
                                                <input type="text"
                                                        class="mgl5"
                                                        style="width:40px; height:25px;line-height: 16px;"
                                                        maxlength="3"
                                                        @keydown="$onbiLib.onlyNumberKeydown()" v-model="orderInfo.tagCnt"
                                                        @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;개
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>납부금액</th>
                                        <td>{{$onbiLib.addComma(orderAmt)}}원</td>
                                    </tr>
                                    <tr v-if="orderInfo.detectorCnt == 0 && orderInfo.tagCnt == 0">
                                        <td colspan="2">
                                            <span class="txt-type4">
                                                리더기 수량 또는 태그 수량을 먼저 입력해주세요.
                                            </span>
                                            <br/>
                                            <span class="txt-type4">
                                                출결상품 구매 시 리더기 , 태그 수량을 필수로 입력해주셔야 합니다.
                                            </span>
                                        </td>
                                    </tr>
                                    <template v-if="orderInfo.detectorCnt > 0||orderInfo.tagCnt > 0">
                                        <tr>
                                            <th>결제요청일</th>
                                            <td>
                                                <vue-datepicker ref="subsidyDatePicker"
                                                :type="'day'"
                                                :sel-callback-func="selSubsidyPayDtCallbackFunc"
                                                :set-date="orderInfo.payDueDt"
                                                :set-btn-class="'_bt-ic11'"
                                                ></vue-datepicker>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>납부방법</th>
                                            <td>
                                                <input type="radio"
                                                    id="paymthdCdrdi01"
                                                    name="paymthdCdrdi01"
                                                    v-model="orderInfo.paymthdCd"
                                                    value="P02"/>
                                                <label for="paymthdCdrdi01">
                                                    <span class="box"></span>
                                                    <span class="label-txt">&nbsp;신용(체크)카드</span>
                                                </label>
                                                <input type="radio"
                                                    id="paymthdCdrdi02"
                                                    name="paymthdCdrdi02"
                                                    v-model="orderInfo.paymthdCd"
                                                    value="P04"/>
                                                <label for="paymthdCdrdi02">
                                                    <span class="box"></span>
                                                    <span class="label-txt">&nbsp;무통장 입금</span>
                                                </label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>납부정보</th>
                                            <td>
                                                <template v-if="orderInfo.paymthdCd == 'P04'">
                                                    <div class="box-type05">
														<table class="tb-none" style="padding:0 10px;">
	                                                        <tr>
	                                                            <th>영업사</th>
	                                                            <td>
	                                                                <select class="select" style="width: 100% !important;" v-model="orderInfo.accSn">
	                                                                    <option v-for="(accInfo, index) in agencyAccList"
	                                                                            :key="'accInfo_'+index" :value="accInfo.accSn">{{accInfo.agencyNm}}</option>
	                                                                </select>
	                                                            </td>
	                                                        </tr>
	                                                        <template v-if="orderInfo.accSn != ''">
	                                                        <tr>
	                                                            <th>은행/계좌번호</th>
	                                                            <td>
	                                                                {{orderAccInfo.bankNm}} / {{orderAccInfo.accNo}}
	                                                            </td>
	                                                        </tr>
	                                                        <tr>
	                                                            <th>예금주명</th>
	                                                            <td>
	                                                                {{orderAccInfo.accNm}}
	                                                            </td>
	                                                        </tr>
	                                                        </template>
	                                                    </table>
	                                                </div>
                                                    <ul class="mgt10 depth2">
														<li>견적서상의 계좌번호로 입금바랍니다.</li>
														<li class="txt-type4">입금자은 '사업자등록번호'로 입금해주시기 바랍니다.('-'제외)</li>
													</ul>
                                                </template>
                                                <template v-if="orderInfo.paymthdCd == 'P02'">
                                                    <span class="txt-type4">납부할 카드는 마이페이지에서 등록해주세요.</span>
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>
<!--                    <div class="balance-sort-con box-type04 mgl5">
                        <div class="__in">
                            <div class="entry-cho">
                                <div class="f-left pdt5">
                                    <label for="chk_002" style="cursor: pointer">
                                        <span class="box"></span>
                                        <span class="label-txt">자부담금</span>
                                    </label>
                                </div>
                                <div class="f-right">
                                    <button class="small _bt-white" @click="openOrderSeInfoPopup()"><span>자세히보기</span></button>
                                </div>
                            </div>
                            <table class="tb-none">
                                <colgroup>
                                    <col style="width:30%" />
                                    <col style="width:*" />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <th>안심등하원 신청 수량</th>
                                        <td>
                                            <span>
                                                리더기 수량 :
                                                <input type="text"
                                                        class="mgl5"
                                                        style="width:40px; height:25px;line-height: 16px;"
                                                        maxlength="3"
                                                        @keydown="$onbiLib.onlyNumberKeydown()" v-model="selfOrderInfo.detectorCnt"
                                                        @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;대,&nbsp;&nbsp;
                                                태그 수량 :
                                                <input type="text"
                                                        class="mgl5"
                                                        style="width:40px; height:25px;line-height: 16px;"
                                                        maxlength="3"
                                                        @keydown="$onbiLib.onlyNumberKeydown()" v-model="selfOrderInfo.tagCnt"
                                                        @keyup="$onbiLib.onlyNumberKeyup()">&nbsp;개
                                            </span>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th>납부금액</th>
                                        <td>{{$onbiLib.addComma(selfAmt)}}원</td>
                                    </tr>
                                    <tr v-if="selfOrderInfo.detectorCnt == 0&&selfOrderInfo.tagCnt == 0">
                                        <td colspan="2">
                                            <span class="txt-type4">
                                                리더기 수량 또는 태그 수량을 먼저 입력해주세요.
                                            </span>
                                            <br/>
                                            <span class="txt-type4">
                                                자부담금으로 결제가 필요없으신 경우 리더기, 태그 수량을 0으로 입력하시면됩니다.
                                            </span>
                                        </td>
                                    </tr>
                                    <template v-if="selfOrderInfo.detectorCnt > 0||selfOrderInfo.tagCnt > 0">
                                        <tr>
                                            <th>결제요청일</th>
                                            <td>
                                                <vue-datepicker ref="subsidyDatePicker"
                                                :type="'day'"
                                                :sel-callback-func="selSelfPayDtCallbackFunc"
                                                :set-date="selfOrderInfo.payDueDt"
                                                :set-btn-class="'_bt-ic11'"
                                                ></vue-datepicker>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>납부방법</th>
                                            <td>
                                                <input type="radio"
                                                    id="paymthdCdrdi03"
                                                    name="paymthdCdrdi03"
                                                    v-model="selfOrderInfo.paymthdCd"
                                                    value="P02"/>
                                                <label for="paymthdCdrdi03">
                                                    <span class="box"></span>
                                                    <span class="label-txt">&nbsp;신용(체크)카드</span>
                                                </label>
                                                <input type="radio"
                                                    id="paymthdCdrdi04"
                                                    name="paymthdCdrdi04"
                                                    v-model="selfOrderInfo.paymthdCd"
                                                    value="P04"/>
                                                <label for="paymthdCdrdi04">
                                                    <span class="box"></span>
                                                    <span class="label-txt">&nbsp;무통장 입금</span>
                                                </label>
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>납부정보</th>
                                            <td>
                                                <template v-if="selfOrderInfo.paymthdCd == 'P04'">
                                                    <table class="tb-col" style="padding:10px;">
                                                        <tr>
                                                            <th>영업사</th>
                                                            <td>
                                                                <select class="select" style="width: 200px !important;" v-model="selfOrderInfo.accSn">
                                                                    <option v-for="(accInfo, index) in agencyAccList"
                                                                            :key="'accInfo_'+index" :value="accInfo.accSn">{{accInfo.agencyNm}}</option>
                                                                </select>
                                                            </td>
                                                        </tr>
                                                        <template v-if="selfOrderInfo.accSn != ''">
                                                        <tr>
                                                            <th>은행 / 계좌번호</th>
                                                            <td>
                                                                {{selfAccInfo.bankNm}} / {{selfAccInfo.accNo}}
                                                            </td>
                                                        </tr>
                                                        <tr>
                                                            <th>예금주명</th>
                                                            <td>
                                                                {{selfAccInfo.accNm}}
                                                            </td>
                                                        </tr>
                                                        </template>
                                                    </table>
                                                    <ul class="mgt5">
                                                        <li class="mgb5">견적서상의 계좌번호로 입금바랍니다.</li>
                                                        <li class="txt-type4">
                                                            입금자명은 '사업자등록번호'로 입금해주시기 바랍니다.<br/>
                                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;('-'제외)
                                                        </li>
                                                    </ul>
                                                </template>
                                                <template v-if="selfOrderInfo.paymthdCd == 'P02'">
                                                    <span class="txt-type4">납부할 카드는 마이페이지에서 등록해주세요.</span>
                                                </template>
                                            </td>
                                        </tr>
                                    </template>
                                </tbody>
                            </table>
                        </div>
                    </div>-->
                </div>
                <div class="txt-type4 __right mgt30"> 월 이용료는 결제처리 직전 아동 현원 기준 가격으로 결제 됩니다.( 결제일은 매월 20일 입니다. / LG U+ LTE 통신비 포함)</div>
                <table class="tb-row" style="padding-top:10px;">
                    <colgroup>
                        <col style="width:16%;">
                        <col style="width:21%;">
                        <col style="width:21%;">
                        <col style="width:21%;">
                        <col style="width:21%;">
                    </colgroup>
                    <tbody>
                    <tr>
                        <th rowspan="2" style="padding:10px !important;">월 이용료(VAT 포함)</th>
                        <td v-for="(goodsInfo,index) in step3.srvcGoodsList"  style="padding:8px !important;"
                            :key="'goodsInfo' + index" class="__center">{{goodsInfo.goodsDc}}</td>
                    </tr>
                    <tr>
                        <td class="last __center" v-for="(goodsInfo,index) in step3.srvcGoodsList"  style="padding:5px !important;"
                            :key="'goodsInfo' + index">{{$onbiLib.addComma(goodsInfo.goodsMtAmount)}}원</td>
                    </tr>
                    <!--
                    <tr>
                        <th style="padding: 10px 15px !important;">결제 방법</th>
                        <td style="padding: 5px 15px !important;" colspan="4">
                            <div class="form-all">
                                <input type="radio"
                                    id="rdi01"
                                    name="payMeans"
                                    v-model="step3.selPayMeansCd"
                                    :value="'P02'">
                                <label for="rdi01">
                                    <span class="box"></span>
                                    <span class="label-txt">&nbsp;신용(체크)카드</span>
                                </label>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <th style="padding: 5px 15px !important;">영수증 발행</th>
                        <td style="padding: 5px 15px !important;" colspan="4">
                            <ul class="txt-type1 depth2">
                                <li>부가가치세법 제 33조 2항 및 제 46조 3항에 의거 카드매출전표 등을 발급한 경우에는 세금계산서를 발급해 드리지 않습니다.</li>
                                <li>신용(체크)카드 결제의 경우 발급받으신 카드매출전표 등을 통하여 매입세액 공제를 받으실 수 있습니다.</li>
                                <li>영수증 발행은 마이페이지에서 가능합니다.</li>
                            </ul>
                        </td>
                    </tr>
                    -->
                    </tbody>
                </table>
                <div class="sv-req-terms-bottom" style="padding: 10px 30px;">
                    <table class="tb-none">
                        <colgroup>
                            <col style="width:*;">
                            <col style="width:15%;">
                        </colgroup>
                        <tbody>
                        <tr>
                            <td style="height:25px">
                                <div class="form-all">
                                    <input type="checkbox" id="chk1" value="SBIW02" v-model="step3.chkAgrees">
                                    <label for="chk1" style="cursor: pointer">
                                        <span class="box"></span>
                                        <span class="label-txt">아이오감 서비스 이용약관에 동의합니다.</span>
                                    </label>
                                </div>
                            </td>
                            <td class="__right" style="height:25px"><button class="middle _bt-white" @click="openTosAgreePopup()"><span>자세히보기</span></button></td>
                        </tr>
                        <tr>
                            <td style="height:25px; padding:0px !important;">
                                <div class="form-all">
                                    <input type="checkbox" id="chk_all" value="ALL" v-model="step3.chkAgrees">
                                    <label for="chk_all" style="cursor: pointer">
                                        <span class="box"></span>
                                        <span class="label-txt">결제할 서비스 내용을 확인하였으며, 구매에 동의합니다. (전자상거래법 제 8조 2항 근거)</span>
                                    </label>
                                </div>
                            </td>
                            <td class="__right" style="height:25px; padding:0px !important;"></td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <div class="btn-wrap center mgt20">
                    <button class="big _bt-white" @click="btn_step3BeforeClick()">
                        <span>이전</span>
                    </button>
                    <button class="big _bt-navy" @click="btn_srvcCompClick()">
                        <span>서비스 신청 완료</span>
                    </button>
                </div>
            </div>
            <div class="grid--con-sub"
                 style="margin:0;width:calc( 100% - 40px ) !important;"
                 v-if="step == 4">
                <div class="sv-req-comp mgt50" style="margin-bottom:50px;">
                    <div class="img-com __icon06">
                        <span>완료 아이콘</span>
                    </div>
                    <div class="entry-title">감사합니다. 서비스 신청이 완료되었습니다.</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    const mixinStep1 = {
        data: function () {
            return {
                step1: {
                    srvcList: new Array()
                }
            }
        },
        methods: {
            searchSrvcList: function(){
                const _this = this;

                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/srvc/searchSrvcList.act',{
                        srvcCd:'SBIW02'
                    }).then(function(response) {
                        let srvcList = response.data.srvcList ;
                        srvcList.forEach(function(srvcInfo){
                            if(srvcInfo.srvcCd == "SBIW02"){
                                srvcInfo.ordr = 1;
                                srvcInfo.srvcDc = '등하원관리/아동관리/교직원관리';
                                srvcInfo.srvcGoodsTitClass = 'single __cho';
                                srvcInfo.srvcGoodsTit = '상품';
                                srvcInfo.showAt = true;
                            }
                            srvcInfo.chkAt = false;
                        });

                        _this.step1.srvcList = srvcList.sort((a, b) => (a.ordr > b.ordr) ? 1 : -1);
                        resolve();
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                });

            },
            btn_srvcReqClick: function(index){
                const _this = this;

                this.reqSrvcList.splice(0,this.reqSrvcList.length);
                this.reqSrvcList.push(this.step1.srvcList[index]);

                this.searchMberRegFcltList().then(function(mberRegFcltList){
                    const param = {
                        mberRegFcltList: mberRegFcltList,
                        reqSrvcList: _this.reqSrvcList,
                        selCallBackFunc: _this.selMberFclt
                    };

                    if (mberRegFcltList.length == 0) {
                        _this.showStep2();
                        _this.step = 2 ;
                    } else {
                        const popupInfo = {
                            se:'modal',
                            id:'selSrvcUseFcltPopup',
                            wid:'450',
                            hei:'397',
                            tit:'서비스 이용 원 선택',
                            draggableAt:false,
                            param:param
                        };

                        _this.$store.commit('openPopup',popupInfo);
                    }
                }).catch(function(e){
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            selMberFclt: function(step,fcltInfo){
                const _this = this;

                if(step == 2){
                    this.showStep2();
                    this.step = 2;
                }else if(step == 3){
                    const keys = Object.keys(fcltInfo);
                    keys.forEach(function(key){
                        if(typeof fcltInfo[key] != 'undefined'){
                            _this.fcltInfo[key] = fcltInfo[key];
                        }
                    })

                    this.showStep3();
                }
            },
            searchMberRegFcltList: function(){
                const _this = this;

                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/srvc/searchMberRegFcltList.act',{
                        mberNo:_this.mberInfo.mberNo
                    }).then(function(response) {
                        resolve(response.data.mberRegFcltList);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                });
            }
        }
    }

    const mixinStep2 = {
        data: function () {
            return {
                step2: {
                    selSidoCode:null,
                    sidoList: new Array(),
                    selSigunCode:null,
                    sigunList: new Array(),
                    selFcltAt: false
                }
            }
        },
        computed: {
            selSidoNm: function(){
                const step2 = this.step2;
                const selSidoInfo = this.step2.sidoList.find(function(info){
                    return info.arcode == step2.selSidoCode;
                });
                if(selSidoInfo == null){ return ''; }
                else{ return  selSidoInfo.arname; }
            },
            selSigunNm: function(){
                const step2 = this.step2;
                const selSigunInfo = this.step2.sigunList.find(function(info){
                    return info.arcode == step2.selSigunCode;
                });
                if(selSigunInfo == null){ return ''; }
                else{ return  selSigunInfo.arname; }
            }
        },
        methods: {
            showStep2: function(){
                const _this = this;
                const step2 = _this.step2;

                this.$onbiLib.searchSidoList().then(function(sidoList){
                    step2.sidoList = step2.sidoList.concat([{arname:'선택해주세요',arcode:null}],sidoList);
                    step2.sigunList = step2.sigunList.concat([{arname:'시/도를 선택해주세요',arcode:null}]);
                }).catch(function(e){
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            sidoChange : function() {
                const step2 = this.step2;
                step2.sigunList = new Array();

                if(step2.selSidoCode!=null){
                    this.$onbiLib.searchSigunList(step2.selSidoCode).then(function(sigunList){
                        step2.selSigunCode = null;
                        step2.sigunList = step2.sigunList.concat([{arname:'선택해주세요',arcode:null}],sigunList);
                    });
                }else{
                    step2.selSigunCode = null;
                    step2.sigunList = step2.sigunList.concat([{arname:'시/도를 선택해주세요',arcode:null}]);
                }
            },
            btn_fcltSearchClick : function() {
                if (this.step2.selSidoCode==null) {
                    this.$toasted.show('시/도를 선택해주세요.');
                    return;
                }
                if (this.step2.selSigunCode==null) {
                    this.$toasted.show('시/군/구를 선택해주세요.');
                    return;
                }
                if (this.fcltInfo.fcltNm==null||this.fcltInfo.fcltNm.replace(/(\s*)/gi,'') == '') {
                    if(this.fcltInfo.fcltNm.replace(/(\s*)/gi,'') == '') this.fcltInfo.fcltNm = '';
                    this.$refs.fcltNm.focus();
                    this.$toasted.show('원명을 입력해주세요.');
                    return;
                }

                const param= {
                    sidoCode: this.step2.selSidoCode,
                    sigunCode: this.step2.selSigunCode,
                    fcltNm: this.fcltInfo.fcltNm,
                    selCallBackFunc: this.setChilCareFcltInfo
                };

                const popupInfo = {
                    se:'modal',
                    id:'searchFcltPopup',
                    wid:'1080',
                    hei:'500',
                    tit:'어린이집 찾기',
                    draggableAt:false,
                    param:param
                };

                this.$store.commit('openPopup',popupInfo);
            },
            setChilCareFcltInfo: function(chilCareFcltInfo,sidoCode,sigunCode){
                const step2 = this.step2;
                step2.selSidoCode = sidoCode;
                this.$onbiLib.searchSigunList(step2.selSidoCode).then(function(sigunList){
                    step2.sigunList = new Array();
                    step2.sigunList = step2.sigunList.concat([{arname:'선택해주세요',arcode:null}],sigunList);
                    step2.selSigunCode = sigunCode;
                });

                this.fcltInfo.areaCd    = sigunCode;
                this.fcltInfo.fcltNm    = chilCareFcltInfo.crname;
                this.fcltInfo.fcltTyCd  = 'I01';
                this.fcltInfo.psncpa    = chilCareFcltInfo.crcapat;
                this.fcltInfo.fcltTy    = chilCareFcltInfo.crcapat>39?'040':'039';
                this.fcltInfo.tlphon    = chilCareFcltInfo.crtel;
                this.fcltInfo.fax       = chilCareFcltInfo.crfax;
                //20200213 문욱제 보육통합 정보 조회 없이 선택가능하도록변경
                /*this.fcltInfo.fcltyTy   = chilCareFcltInfo.crtype;
                this.fcltInfo.fcltyTyNm = chilCareFcltInfo.crtypename;*/
                this.fcltInfo.stcode    = chilCareFcltInfo.stcode;
                this.fcltInfo.adres     = chilCareFcltInfo.craddr;
                const zip = chilCareFcltInfo.zipcode;
                this.fcltInfo.zip       = zip.substring(0,3)+'-' + zip.substring(3);
                step2.selFcltAt = true;
            },
            step2Clear: function(){
                const _this = this;
                this.step2.selFcltAt = false;
                this.step2.selSidoCode = null;
                this.step2.sidoList = new Array();
                this.step2.selSigunCode = null;
                this.step2.sigunList = new Array();

                const keys = Object.keys(this.fcltInfo);
                keys.forEach(function(key){
                    if(key == 'psncpa'){ _this.fcltInfo[key] = '0'; }
                    else if(key == 'areaCd'){ _this.fcltInfo[key] = null; }
                    else{ _this.fcltInfo[key] = ''; }
                })
            },
            btn_step2BeforeClick: function(){
                this.step2Clear();
                this.step = 1;
            },
            chkBizID: function (){
                return true; //임시
            },
            btn_fcltRegClick : function(){
                const _this = this;
                this.fcltInfo.bizrno = this.fcltInfo.bizrno1 + this.fcltInfo.bizrno2 + this.fcltInfo.bizrno3;

                if(this.fcltInfo.stcode==''){
                    this.$toasted.show('어린이집을 검색하셔서 선택해주십시오.');
                    return ;
                }

                if(this.fcltInfo.bizrno == ''){
                    this.$toasted.show('고유번호(사업자등록번호)를 입력해주세요');
                    return;
                }

                if(this.fcltInfo.bizrno.length < 10){
                    this.$toasted.show('고유번호(사업자등록번호)를 10자리로 입력해주세요');
                    return;
                }

                if(!this.chkBizID(this.fcltInfo.bizrno)){
                    this.$toasted.show('유효하지 않은 사업자 등록번호입니다.');
                    return;
                }

                if(this.fcltInfo.ledgrNm.replace(/(\s*)/gi,'') == ''){
                    this.fcltInfo.ledgrNm = this.fcltInfo.ledgrNm.replace(/(\s*)/gi,'');
                    this.$toasted.show('원장명을 입력해주세요.');
                    return;
                }

                this.fcltInfo.mberNo = this.mberInfo.mberNo;

                this.searchStcodeCnt().then(function(procInfo){
                    if(Number(procInfo.joinCnt) > 0){
                        _this.$store.commit('closePopup');

                        const popupInfo = {
                            se:'modal',
                            id:'searchFcltOvrlpPopup',
                            wid:'650',
                            hei:'',
                            tit:'원 중복 신청 안내 팝업',
                            draggableAt:false,
                        };
                        _this.$store.commit('openPopup',popupInfo);
                        return;
                    }else{
                        _this.axios.post('/i5gam/srvc/saveFcltInfoProc.act',{
                            fcltInfo : _this.fcltInfo
                        }).then(function(response) {
                            const procInfo = response.data.procInfo;
                            const procCode = procInfo.procCode;

                            if(procCode == '000'){
                                _this.fcltInfo.fcltcd = procInfo.fcltcd;
                                _this.showStep3();
                            }else{ _this.$toasted.show(_this.$onbiLib.msg.err.system); }
                        }.bind(_this)).catch(function(e) {
                            console.log(e);
                            _this.$toasted.show(_this.$onbiLib.msg.err.system);
                        });
                    }
                })
            },
            searchStcodeCnt : function(){
                const _this = this;
                return new Promise(function(resolve, reject){
                    _this.axios.post('/i5gam/srvc/searchStcodeCnt.act',{
                        fcltInfo : _this.fcltInfo
                    }).then(function(response) {
                        resolve(response.data.procInfo);
                    }.bind(_this)).catch(function(e) {
                        reject(e);
                    });
                })
            }
        }
    }

    const mixinStep3 = {
        data: function () {
            return {
                step3: {
                    srvcGoodsList: new Array(),
                    selPayTypeCd:'PT1',
                    payTypeList: [
                        {payTypeCd:'PT1',payTypeNm:'월 정기 결제'},
                        {payTypeCd:'PT4',payTypeNm:'연 정기 결제'}
                    ],
                    selPayMeansCd:'P02',
                    chkAgrees:[],
                    srvcInfo : {
                        paymthdCd : 'P02',
                        bankCd : '011',
                    },
                    bankList : [
                        {bankCd : '011', bankNm : '농협', accountNm : '(주)온앤온정보시스템', accountNo : '089-01-313643'},
                        {bankCd : '004', bankNm : '국민', accountNm : '(주)온앤온정보시스템', accountNo : '828-2010-4068-953'},
                        {bankCd : '088', bankNm : '신한', accountNm : '(주)온앤온정보시스템', accountNo : '140-00748-8045'},
                        {bankCd : '020', bankNm : '우리', accountNm : '(주)온앤온정보시스템', accountNo : '1005-280-121211'},
                    ],
                    tagCfmAt : 'N',
                }
            }
        },
        computed: {
            orderAmt : function(){
                const orderInfo = this.orderInfo;
                let detectorAmt = 0;

                /*
                if(orderInfo.detectorCnt > 1){
                    detectorAmt = 300000*1 + 220000 * Number(orderInfo.detectorCnt-1);
                }else{
                     detectorAmt = 300000 * Number(orderInfo.detectorCnt);
                }
                */

                detectorAmt = 300000 * Number(orderInfo.detectorCnt);
                let tagAmt = Number(orderInfo.tagCnt) * 5000;
                return detectorAmt + tagAmt;
            },
            /*selfAmt : function(){
                const orderInfo = this.orderInfo;
                const selfOrderInfo = this.selfOrderInfo;
                let detectorAmt = 0;

                if(this.selfOrderInfo.detectorCnt > 0){
                    if(Number(orderInfo.detectorCnt) > 0 ){
                        detectorAmt = 220000 * selfOrderInfo.detectorCnt;
                    }else{
                        detectorAmt = 300000*1 + 220000 * Number(selfOrderInfo.detectorCnt-1);
                    }
                }

                let tagAmt = Number(selfOrderInfo.tagCnt) * 5000;
                return detectorAmt + tagAmt;
            },*/
            orderAccInfo : function(){
                const accSn = this.orderInfo.accSn;
                const accInfo = this.agencyAccList.find(function(info){
                    return info.accSn == accSn;
                });

                console.log(accInfo);
                return accInfo;
            },
            /*selfAccInfo : function(){
                const accSn = this.selfOrderInfo.accSn;
                const accInfo = this.agencyAccList.find(function(info){
                    return info.accSn == accSn;
                });

                return accInfo;
            }*/
        },
        methods: {
            openOrderSeInfoPopup : function(){
                const popupInfo = {
                    se:'modal',
                    id:'orderSeInfoPopup',
                    wid:'670',
                    hei:'',
                    tit:'정산 구분 안내',
                    draggableAt:false,
                };

                this.$store.commit('openPopup',popupInfo);
            },
            showStep3: function(){
                const _this = this;
                let srvcCd = '';

                this.openOrderSeInfoPopup();

                if(this.reqSrvcList.length > 0){ srvcCd = this.reqSrvcList[0].srvcCd; }
                else{ this.$toasted.show(this.$onbiLib.msg.err.system); }

                this.axios.post('/i5gam/srvc/searchSrvcGoodsList.act',{
                    srvcCd: srvcCd,
                }).then(function(response) {
                    this.step3.srvcGoodsList = response.data.srvcGoodsList.sort((a, b) => (a.goodsMtAmount > b.goodsMtAmount) ? 1 : -1);
                    this.searchI5gamExlTagOrder();
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            searchI5gamExlTagOrder : function(){
                const _this = this;

                this.axios.post('/i5gam/srvc/searchI5gamExlTagOrder.act',{
                    stcode : this.fcltInfo.stcode
                }).then(function(response) {
                    const procInfo = response.data.procInfo;
                    if(procInfo.orderYn == 'Y'){
                        _this.orderInfo = procInfo.orderInfo;
                        _this.step3.tagCfmAt = procInfo.orderInfo.tagCfm == '100' ? 'Y' : 'N';
                        _this.agencyNo = procInfo.orderInfo.agencyNo;
                    }else{
                        _this.orderInfo = JSON.parse(JSON.stringify(this.defOrderInfo));
                    }

                    /*if(procInfo.selfOrderYn == 'Y'){
                        _this.selfOrderInfo = procInfo.selfOrderInfo;
                        _this.step3.tagCfmAt = procInfo.selfOrderInfo.tagCfm == '100' ? 'Y' : 'N';
                        _this.agencyNo = procInfo.selfOrderInfo.agencyNo;
                    }else{
                        _this.selfOrderInfo = JSON.parse(JSON.stringify(this.defSelfOrderInfo));
                    }*/

                    if(procInfo.addOrderYn == 'Y'){
                        _this.addOrderInfo = procInfo.addOrderInfo;
                        _this.step3.tagCfmAt = procInfo.addOrderInfo.tagCfm == '100' ? 'Y' : 'N';
                        _this.agencyNo = procInfo.addOrderInfo.agencyNo;
                    }

                    _this.step = 3;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            step3Clear: function(){
                this.step3.srvcGoodsList = new Array();
                this.step3.selPayTypeCd  = 'PT1';
                this.step3.selPayMeansCd = 'P02';
                this.step3.chkAgrees     = [];
            },
            btn_step3BeforeClick: function(){
                this.step3Clear();
                this.btn_step2BeforeClick();
            },
            chkValid: function(){
                let clearSrvcAgreeAt = true;
                const _this = this;

                if(this.orderInfo.detectorCnt == 0&&this.orderInfo.tagCnt == 0){
                    this.$toasted.show('출결상품 구매 시 리더기 또는 태그 수량은 필수 입력 사항입니다.');
                    return true;
                }

                if(this.orderInfo.detectorCnt > 0||this.orderInfo.tagCnt > 0){
                    if(this.orderInfo.payDueDt == ''){
                        this.$toasted.show("출결상품 구매  결제신청일을 선택해주세요.");
                        return true;
                    }

                    if(this.orderInfo.paymthdCd == ''){
                        this.$toasted.show("출결상품 구매 납부방법을 선택해주세요.");
                        return true;
                    }
                }

                /*if(this.selfOrderInfo.detectorCnt > 0 || this.selfOrderInfo.tagCnt > 0){
                    if(this.selfOrderInfo.payDueDt == ''){
                        _this.$toasted.show('결제요청일을 선택해주세요.');
                        return true;
                    }

                    if(this.selfOrderInfo.paymthdCd == ''){
                        _this.$toasted.show('자부담금 납부방법을 선택해주세요.');
                        return true;
                    }
                }*/


                this.reqSrvcList.forEach(function(info){
                    const chkIdx = _this.step3.chkAgrees.findIndex(function(chkVal){return chkVal == info.srvcCd;});
                    if(chkIdx == -1){
                        _this.$toasted.show(info.srvcNm + ' 서비스 이용약관에 동의하셔야 합니다.');
                        clearSrvcAgreeAt = false;
                    }
                });

                if(!clearSrvcAgreeAt) return true;

                const chkIdx = _this.step3.chkAgrees.findIndex(function(chkVal){return chkVal == 'ALL';});

                if(chkIdx == -1){
                    this.$toasted.show('서비스 내용확인 및 구매에 동의해 주셔야 합니다.');
                    return true;
                }
            },
            btn_srvcCompClick : function(){
                const _this = this;
                const step3 = this.step3;

                if(this.chkValid()){ return false; }

                /*추가 결제방법이 추가되면 로직을 추가하도록하자.*/
                const payTypeInfo = step3.payTypeList.find(function(info){
                    return info.payTypeCd == step3.selPayTypeCd;
                });
                const rm = '카드(빌링)-' + payTypeInfo.payTypeNm;

                this.axios.post('/i5gam/srvc/srvcCompProc.act',{
                    srvcGoodsList:_this.getFcltGoodsList(),
                    orderInfo : this.orderInfo, //보조금
                    //selfOrderInfo : this.selfOrderInfo, //자부담금
                    addOrderInfo : this.addOrderInfo,   //추가수량
                    tagCfmAt : step3.tagCfmAt,  //태그 확정여부
                    srvcTempInfo:{
                        mberNo:_this.mberInfo.mberNo,
                        mberNm:_this.mberInfo.mberNm,
                        cttpc:_this.mberInfo.cttpc,
                        email:_this.mberInfo.email,
                        fcltcd:_this.fcltInfo.fcltcd,
                        svcSttus:'APR',
                        svcAccesAt:'N',
                        payTypeCd: step3.selPayTypeCd,
                        paymthdCd:step3.selPayMeansCd,
                        rm:rm,
                        reqDefrayDe:'20',/*현재 결재일 20일로 설정 추후 바귈수있음*/
                        srvcPeriod:30,
                        agencyNo:_this.agencyNo,
                    }
                }).then(function(response) {
                    const procInfo = response.data.procInfo;
                    if(procInfo.procCode == '000'){
                        this.step = 4;
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            getFcltGoodsList: function(){
                const step3 = this.step3;

                let setGoodsCd = 'GBIW05';
                if(Number(this.fcltInfo.psncpa) >= 21 && Number(this.fcltInfo.psncpa) <= 40){
                    setGoodsCd = 'GBIW06';
                }else if(Number(this.fcltInfo.psncpa) >= 41 && Number(this.fcltInfo.psncpa) <= 80){
                    setGoodsCd = 'GBIW07';
                }else if(Number(this.fcltInfo.psncpa) >= 81){
                    setGoodsCd = 'GBIW08';
                }

                return step3.srvcGoodsList.filter(function(info){
                    return info.goodsCd == setGoodsCd;
                })
            },
            openTosAgreePopup: function(){
                const popupInfo = {
                    se:'modal',
                    id:'tosAgreePopup',
                    wid:'700',
                    hei:'',
                    tit:'이용약관 동의',
                    draggableAt:true,
                    param:null
                };

                this.$store.commit('openPopup',popupInfo);
            },
            selSubsidyPayDtCallbackFunc : function(date){
                this.orderInfo.payDueDt = date;
            },
            /*selSelfPayDtCallbackFunc : function(date){
                this.selfOrderInfo.payDueDt = date;
            },*/
            /*
            btn_regPayCardClick: function(){
                const _this = this;
                if(this.chkValid()){ return false; }

                this.searchBillCardList().then(function(billCardList){
                    if(billCardList.length > 0){
                        const param = {
                            billCardSn : '',
                            billCardList : billCardList,
                            regNewBillCardFunc:_this.regNewBillCard,
                            regBillCardFunc:_this.regBillCard
                        }

                        const popupInfo = {
                            se:'modal',
                            id:'billCardListPopup',
                            wid:'860',
                            hei:'',
                            tit:'결제 카드 등록',
                            draggableAt:false,
                            param:param
                        };

                        _this.$store.commit('openPopup',popupInfo);
                    }else{
                        _this.regNewBillCard();
                    }
                }).catch(function (e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            searchBillCardList : function(){
                const _this = this;
                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/srvc/searchBillCardList.act',{
                        mberNo : _this.mberInfo.mberNo
                    }).then(function(response) {
                        resolve(response.data.billCardList);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });

                });
            },
            saveSrvcTempProc : function(){
                const _this = this;
                const step3 = _this.step3;

                const payTypeInfo = step3.payTypeList.find(function(info){
                    return info.payTypeCd == step3.selPayTypeCd;
                });
                const rm = '카드(빌링)-' + payTypeInfo.payTypeNm;

                return new Promise(function (resolve, reject) {
                    _this.axios.post('/i5gam/srvc/saveSrvcTempProc.act',{
                        srvcGoodsList:_this.getFcltGoodsList(),
                        srvcTempInfo:{
                            mberNo:_this.mberInfo.mberNo,
                            mberNm:_this.mberInfo.mberNm,
                            cttpc:_this.mberInfo.cttpc,
                            email:_this.mberInfo.email,
                            fcltcd:_this.fcltInfo.fcltcd,
                            svcSttus:'APR',
                            svcAccesAt:'N',
                            payTypeCd: step3.selPayTypeCd,
                            paymthdCd:step3.selPayMeansCd,
                            rm:rm,
                            reqDefrayDe:'20', //현재 결재일 20일로 설정 추후 바귈수있음
                            srvcPeriod:30,
                            agencyNo:_this.agencyNo,
                        }
                    }).then(function(response) {
                        const procInfo = response.data.procInfo;
                        resolve(procInfo);
                    }.bind(this)).catch(function(e) {
                        reject(e);
                    });
                });
            },
            saveI5gamTagInfo : function(){
                const _this = this;

                this.axios.post('/i5gam/srvc/saveI5gamTagInfo.act',{
                    orderInfo : this.orderInfo,
                    selfOrderInfo : this.selfOrderInfo,
                    addOrderInfo : this.addOrderInfo,
                    srvcInfo : this.step3.srvcInfo,
                    tagCfmAt : this.step3.tagCfmAt
                }).then(function() {
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            regNewBillCard: function(){
                const _this = this;

                this.saveSrvcTempProc().then(function(procInfo){
                    if(typeof(procInfo) != "undefined"&&procInfo != null){
                        var procCode = procInfo.procCode;
                        if(procCode == '000'){
                            const srvcGoodsList = procInfo.srvcGoodsList;
                            const srvcGoodsInfo = srvcGoodsList[0];

                            //주문 수량 저장
                            _this.orderInfo.reqstSn = srvcGoodsInfo.reqstSn;
                            _this.selfOrderInfo.reqstSn = srvcGoodsInfo.reqstSn;
                            if(_this.addOrderInfo != null) _this.addOrderInfo.reqstSn = srvcGoodsInfo.reqstSn;

                            _this.saveI5gamTagInfo();

                            const param = {
                                procSe: 'srvcReq',
                                reqstSn: srvcGoodsInfo.reqstSn,
                                goodsCd: srvcGoodsInfo.goodsCd,
                                goodsNm: srvcGoodsInfo.goodsNm,
                                goodsMtAmount: srvcGoodsInfo.goodsMtAmount,
                                goodsYearAmount: srvcGoodsInfo.goodsYearAmount,
                                payTypeCd: srvcGoodsInfo.payTypeCd,
                                paymthdCd: srvcGoodsInfo.paymthdCd,
                                fcltcd: srvcGoodsInfo.fcltcd,
                                mberNo: srvcGoodsInfo.mberNo,
                                mberNm: srvcGoodsInfo.mberNm,
                                cttpc: srvcGoodsInfo.cttpc,
                                email: srvcGoodsInfo.email,
                                reqDefrayDe: srvcGoodsInfo.reqDefrayDe,
                                rm: srvcGoodsInfo.rm,
                                callBackFunc:_this.srvcReqFinish
                            };

                            const popupInfo = {
                                se:'modalBlank',
                                id:'iniPayReqBillPopup',
                                wid:'820',
                                hei:'600',
                                tit:'이니시스결제',
                                draggableAt:false,
                                param:param
                            };

                            _this.$store.commit('openPopup',popupInfo);
                        }
                    }
                }).catch(function (e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            regBillCard: function(billCardInfo,popupIndex){
                var _this = this;

                this.saveSrvcTempProc().then(function(procInfo){
                    var procCode = procInfo.procCode;
                    if(procCode == '000'){
                        const srvcGoodsList = procInfo.srvcGoodsList;
                        const srvcGoodsInfo = srvcGoodsList[0];

                        //주문 수량 저장
                        _this.orderInfo.reqstSn = srvcGoodsInfo.reqstSn;
                        _this.selfOrderInfo.reqstSn = srvcGoodsInfo.reqstSn;
                        if(_this.addOrderInfo != null) _this.addOrderInfo.reqstSn = srvcGoodsInfo.reqstSn;

                        _this.saveI5gamTagInfo();

                        let totPrice = srvcGoodsInfo.goodsYearAmount;

                        if(srvcGoodsInfo.payTypeCd == 'PT1'){
                            totPrice= srvcGoodsInfo.goodsMtAmount;
                        }

                        _this.axios.post('/i5gam/srvc/srvcReqProc.act',{
                            payTypeCd :srvcGoodsInfo.payTypeCd,
                            paymthdCd :srvcGoodsInfo.paymthdCd,
                            totPrice  :totPrice,
                            reqstSn   :srvcGoodsInfo.reqstSn,
                            mberNo    :srvcGoodsInfo.mberNo,
                            fcltcd    :srvcGoodsInfo.fcltcd,
                            goodsCd   :srvcGoodsInfo.goodsCd,
                            billCardSn:billCardInfo.billCardSn
                        }).then(function(response) {
                            const srvcReqProcInfo = response.data.procInfo;

                            if(typeof srvcReqProcInfo != 'undefined'&&srvcReqProcInfo != null){
                                if(srvcReqProcInfo.procCode == '000'){
                                    _this.srvcReqFinish(popupIndex);
                                }else{
                                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                                }
                            }else{
                                _this.$toasted.show(_this.$onbiLib.msg.err.system);
                            }
                        }.bind(this)).catch(function(e) {
                            console.log(e);
                            _this.$toasted.show(_this.$onbiLib.msg.err.system);
                        });
                    }
                }).catch(function (e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            srvcReqFinish:function(popupIndex){
                console.log('srvcReqFinish');
                const _this = this;

                _this.axios.post('/i5gam/srvc/chkBo6inUseAt.act',{  //보육인 사용하는 원인지 체크
                    fcltcd : this.fcltInfo.fcltcd,
                }).then(function(response) {
                    const procInfo = response.data.procInfo;
                    console.log(procInfo);
                    if(procInfo.procCode == '000'){
                        this.$store.commit('closePopup',popupIndex);
                        this.step = 4;
                    }
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            },
            */
        }
    }

    export default {
        name: 'srvcReq_popup',
        mixins: [mixinStep1,mixinStep2,mixinStep3],
        data: function(){
            return {
                showAt: false,
                step: 1,
                agencyNo:'AG0000000001',
                reqSrvcList: new Array(),
                agencyAccList : new Array(),
                fcltInfo: {
                    fcltcd:'',
                    fcltNm:'',
                    psncpa:'0',
                    fcltTy:'',
                    rprsntvNm:'',
                    ledgrNm:'',
                    bizrno:'',
                    bizrno1:'',
                    bizrno2:'',
                    bizrno3:'',
                    areaCd:null,
                    tlphon:'',
                    fax:'',
                    fcltyTy:'',
                    fcltyTyNm:'',
                    crtfcTy:'',
                    fcltTyCd:'',
                    mberNo:'',
                    stcode:'',
                    adres:'',
                    zip:''
                },
                defOrderInfo : {
                    reqstSn : '',
                    orderSe : '001',
                    tagSe : 'NFC',
                    detectorCnt : '1',
                    tagCnt : '0',
                    payDueDt : null,
                    paymthdCd : 'P04',
                    bankCd : '',
                    accountNo : '',
                    srvcAmt : '300000',
                    accSn : '',
                },
                /*defSelfOrderInfo : {
                    reqstSn : '',
                    orderSe : '002',
                    tagSe : 'NFC',
                    detectorCnt : '0',
                    tagCnt : '0',
                    payDueDt : null,
                    paymthdCd : 'P04',
                    bankCd : '',
                    accountNo : '',
                    accSn : '',
                },*/
                orderInfo : {},
                //selfOrderInfo : {},
                addOrderInfo : null
            }
        },
        computed: {
            mberInfo: function(){
                return this.$store.getters.getMberInfo;
            },
            dayInfo: function(){
                return this.$store.getters.getDayInfo;
            }
        },
        methods : {
            searchAgencyAccList : function(){
                const _this = this;
                this.axios.post('/i5gam/srvc/searchAgencyAccList.act',{
                }).then(function(response) {
                    let agencyAccList = response.data.agencyAccList;
                    agencyAccList.splice(0,0,{accSn:'', agencyNm : '선택'});
                    _this.agencyAccList = agencyAccList;
                    _this.showAt = true;
                }.bind(this)).catch(function(e) {
                    console.log(e);
                    _this.$toasted.show(_this.$onbiLib.msg.err.system);
                });
            }
        },
        mounted: function() {
            this.searchSrvcList().then(function(){
                this.defOrderInfo.payDueDt = this.dayInfo.ymd;
                //this.defSelfOrderInfo.payDueDt = _this.dayInfo.ymd;
                //this.step3.orderInfo = JSON.parse(JSON.stringify(this.defOrderInfo));
                //this.step3.selfOrderInfo = JSON.parse(JSON.stringify(this.selfSelfOrderInfo));
                this.searchAgencyAccList();
            }.bind(this)).catch(function(e){
                console.log(e);
                this.$toasted.show(this.$onbiLib.msg.err.system);
            }.bind(this));
        }
    }
</script>

<style scoped>

</style>
